
import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCcw } from 'lucide-react';
import { register } from '@/serviceWorker';

// Component to handle service worker updates
const ServiceWorkerUpdater: React.FC = () => {
  const [waitingServiceWorker, setWaitingServiceWorker] = useState<ServiceWorker | null>(null);
  const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      // Add listener for new service workers
      const onUpdate = (registration: ServiceWorkerRegistration) => {
        setIsUpdateAvailable(true);
        setWaitingServiceWorker(registration.waiting);
      };

      // Register the service worker and set up the listener
      register({
        onUpdate,
        onOffline: () => console.log('App is now offline'),
        onOnline: () => console.log('App is now online'),
      });
    }
  }, []);

  const updateServiceWorker = () => {
    if (waitingServiceWorker) {
      // Send a message to the service worker to activate it
      waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });

      waitingServiceWorker.addEventListener('statechange', (event) => {
        if ((event.target as ServiceWorker).state === 'activated') {
          window.location.reload();
        }
      });
    }
  };

  if (!isUpdateAvailable) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 z-50 bg-primary text-primary-foreground p-3 rounded-lg shadow-lg">
      <div className="flex items-center gap-2">
        <RefreshCcw size={16} className="animate-spin" />
        <span>New version available!</span>
        <Button 
          size="sm" 
          variant="secondary" 
          onClick={updateServiceWorker}
          className="ml-2"
        >
          Update
        </Button>
      </div>
    </div>
  );
};

export default ServiceWorkerUpdater;
